import { useState } from 'react'
import { createPortal } from 'react-dom'
import { SELLER_ENTITY_LABELS_RU, SellerEntity } from '@crm/shared'

/**
 * Вопрос «чьё это юрлицо?» при первой выписке по расчётному счёту. Без юрлица
 * программа не ищет заказ по номеру счёта (нумерация 1С своя у каждого юрлица),
 * поэтому спрашиваем до загрузки — тогда выписка разнесётся сразу.
 */
export function BankEntityPrompt({
  accountNumber,
  ownerName,
  onPick,
  onCancel,
}: {
  accountNumber: string
  ownerName: string
  onPick: (entityId: SellerEntity) => void
  onCancel: () => void
}) {
  const [value, setValue] = useState<SellerEntity | ''>('')
  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 p-4">
      <div
        role="dialog"
        aria-label="Юрлицо расчётного счёта"
        className="w-full max-w-md rounded-xl border border-gray-200 bg-white shadow-xl"
      >
        <div className="border-b border-gray-100 px-4 py-3">
          <h3 className="text-sm font-semibold text-gray-800">Чей это расчётный счёт?</h3>
        </div>
        <div className="space-y-3 p-4 text-sm">
          <p className="text-gray-700">
            По счёту <span className="font-mono">{accountNumber}</span>
            {ownerName ? ` (${ownerName})` : ''} юрлицо ещё не указано. Выберите его один раз —
            дальше программа запомнит.
          </p>
          <div className="space-y-2">
            {Object.values(SellerEntity).map((code) => (
              <label key={code} className="flex items-center gap-2">
                <input
                  type="radio"
                  name="bank-entity"
                  checked={value === code}
                  onChange={() => setValue(code)}
                  className="border-gray-300 text-brand-600 focus:ring-brand-500"
                />
                {SELLER_ENTITY_LABELS_RU[code]}
              </label>
            ))}
          </div>
          <p className="text-xs text-gray-500">
            Номера счетов 1С у каждого юрлица свои — без юрлица поступления не привяжутся к заказам
            по номеру счёта.
          </p>
        </div>
        <div className="flex justify-end gap-2 border-t border-gray-100 px-4 py-3">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-lg px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900"
          >
            Отмена
          </button>
          <button
            type="button"
            disabled={!value}
            onClick={() => value && onPick(value)}
            className="px-3 py-1.5 bg-brand-600 text-white text-sm rounded-lg hover:bg-brand-700 transition-colors disabled:opacity-60"
          >
            Загрузить выписку
          </button>
        </div>
      </div>
    </div>,
    document.body,
  )
}
